module.exports = __webpack_public_path__ + "img/404.0f200fc2.png";